import { supabase } from '../config/supabase';
import { TABLES } from '../data/tables';
import { City } from '../data/types/domain';

export const cityService = {
  async getCities(): Promise<City[]> {
    const { data, error } = await supabase
      .from(TABLES.CITY)
      .select('*');
    
    if (error) throw error;
    return data || [];
  },

  async getCityById(id: number): Promise<City | null> {
    const { data, error } = await supabase
      .from(TABLES.CITY)
      .select('*')
      .eq('id', id)
      .single();
    
    if (error) throw error;
    return data || null;
  },

  async getCitiesByCountry(countryId: number): Promise<City[]> {
    const { data, error } = await supabase
      .from(TABLES.CITY)
      .select('*')
      .eq('country_id', countryId);
    
    if (error) throw error;
    return data || [];
  },

  async createCity(city: Omit<City, 'id' | 'created_at' | 'updated_at'>): Promise<City> {
    const { data, error } = await supabase
      .from(TABLES.CITY)
      .insert([{
        ...city,
        created_at: new Date().toISOString(),
        updated_at: new Date().toISOString(),
      }])
      .select()
      .single();
    
    if (error) throw error;
    return data;
  },

  async updateCity(
    id: number,
    updates: Partial<Omit<City, 'id' | 'created_at' | 'updated_at'>>
  ): Promise<City> {
    const { data, error } = await supabase
      .from(TABLES.CITY)
      .update({
        ...updates,
        updated_at: new Date().toISOString(),
      })
      .eq('id', id)
      .select()
      .single();
    
    if (error) throw error;
    return data;
  },

  async deleteCity(id: number): Promise<void> {
    const { error } = await supabase
      .from(TABLES.CITY)
      .delete()
      .eq('id', id);
    
    if (error) throw error;
  },

  async updateName(id: number, name: string): Promise<City> {
    return this.updateCity(id, { name });
  },

  async updateCountry(id: number, countryId: number): Promise<City> {
    return this.updateCity(id, { country_id: countryId });
  },

  findCityByNameAndCountry: async (cityName: string, countryName: string) => {
    const { data: existingCity } = await supabase
      .from(TABLES.CITY)
      .select('*, country:country_id(*)')
      .ilike('name', cityName)
      .eq('country.name', countryName)
      .single();
    
    return existingCity;
  }
}; 